import { render } from "./GlobalTimer.vue?vue&type=template&id=5992d316&scoped=true"
import script from "./GlobalTimer.vue?vue&type=script&lang=js"
export * from "./GlobalTimer.vue?vue&type=script&lang=js"

import "./GlobalTimer.vue?vue&type=style&index=0&id=5992d316&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5992d316"]])

export default __exports__